import { FC, useState } from 'react'
import { Label } from './label'
import { Input } from './input'
import { ModalForm } from '../notifications/modal/ModalForm'

interface Props {
  initialValue?: string
  inputLabel: string
  onCancel: () => void
  onSave: (name: string) => Promise<void>
  saveButtonText?: string
}

export const ResourceNameForm: FC<Props> = ({
  initialValue = '',
  inputLabel,
  onCancel,
  onSave,
  saveButtonText,
}) => {
  const [name, setName] = useState(initialValue)
  const [isSaving, setIsSaving] = useState(false)

  const save = () => {
    setIsSaving(true)
    void onSave(name).finally(() => setIsSaving(false))
  }

  return (
    <ModalForm
      fields={
        <div>
          <Label>{inputLabel}</Label>
          <Input
            autoFocus
            value={name}
            onChange={(event) => setName(event.target.value)}
            required
          />
        </div>
      }
      onCancel={onCancel}
      onSave={save}
      isSaving={isSaving}
      saveButtonText={saveButtonText}
      submitOnEnter
    />
  )
}